<template>
  <div class="container mx-auto my-10 rounded-lg shadow-lg">
    <TeamSearch></TeamSearch>
  </div>
</template>

<script>
import TeamSearch from './components/TeamSearch.vue'

export default {
  name: 'app',
  components: {
    TeamSearch
  }
}
</script>